import {useNavigate, useSearchParams} from 'react-router-dom'
import LoadingBackdrop from '../../components/LoadingBackdrop'
import {useEffect} from 'react'

export default function DeckRedirect() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const deckId = searchParams.get('deckId')
    if (!deckId) {
      navigate('/')
      return
    }
    navigate(`/deck/${deckId}`)
  }, [])
  
  return (
    <>
      <LoadingBackdrop loading={true}/>
    </>
    
  )
}
